import * as types from './mutations';

export const actions = {
  async 'organization.create'({ commit }, { name, email }) {
    await this.$axios.$post(`organizations`, { name, email });
  },

  async 'organization.update'({ commit }, { name, address }) {
    const orga = await this.$axios.$patch(`organizations`, { name, address });
    commit(types.UPDATE_ORGANIZATION, orga);
    return orga;
  },

  async 'organization.updatePicture'({ commit }, { imageFile }) {
    const data = new FormData();
    data.append('Image', imageFile);

    return await this.$axios.$post(`organizations/pictures`, data);
  },

  async 'organization.deletePicture'() {
    return this.$axios.$delete(`organizations/pictures`);
  },

  async 'organization.fetch'({ commit }) {
    const orga = await this.$axios.$get(`organizations`);
    commit(types.UPDATE_ORGANIZATION, orga);
    return orga;
  },

  async 'organization.kickUser'({ commit }, userId) {
    await this.$axios.$put(`organizations/kick`, { userId });
    commit(types.RESET_ORGANIZATION);
  },

  async 'organization.inviteUser'({ commit }, { email }) {
    return await this.$axios.$post(`organizations/sendinvitation`, { email });
  },

  async 'organization.delete'({ commit }, userId) {
    await this.$axios.$delete(`organizations`);
  },
};
